import { Box, Stack, styled, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(3),
  gap: theme.spacing(2),
  border: `1px solid`,
  borderColor: theme.palette.warning.main,
  background: theme.palette.grey[800],
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    '& > button': {
      alignSelf: 'flex-end',
    },
  },
}));

export const StyledTextSection = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
}));

export const StyledTextContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.5),
  alignItems: 'center',
}));

export const StyledTitleTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.warning.main,
  fontSize: 16,
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: theme.spacing(3),
}));

export const StyledTypography = styled(Typography)({
  fontSize: 12,
  fontStyle: 'normal',
});

export const StyledCheckIcon = styled(CheckIcon)({
  fontSize: 'inherit',
  color: 'inherit',
});
